import React from "react";
import { Layout } from "antd";

const { Footer } = Layout;
const footer = () => {
  return (
    <div>
      <Footer style={{ textAlign: "center" }}>
        CPU Scheduler 2021 Created by Team Locality
      </Footer>
    </div>
  );
};

export default footer;
